import { useEffect, useState } from "react";
import "../styles/board.scss";
import Header from "../components/header";
import Footer from "../components/footer"
import MenuTab from "../components/menu_tab";
import Banner from "../components/banner";
import Button from "../components/button";
import personicon from "../assets/imgs/personicon.jpg"
import md from "../assets/imgs/board/MD.jpg";
import Godfrey from "../assets/imgs/board/Godfrey.png";
import WillyKimani from "../assets/imgs/board/WillyKimani.jpg";
import GNKangara from "../assets/imgs/board/GNKangara.png";
import Grace from "../assets/imgs/board/Grace.jpg";
// import James from "../assets/imgs/board/James.jpg";
import Silas from "../assets/imgs/board/Fr.SilasNgaruiya.jpeg";
import Solomon from "../assets/imgs/board/Solomon.png";
import Edmund from "../assets/imgs/board/EdmundNjihia.png";
import Peter from "../assets/imgs/board/Rev_Peter_Wangaruro.jpg";

export default function Board (props) {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleQuickServices, setToggleQuickServices] = useState(false);
  
  return (
    <div className="body">
      <Banner />
      <Header toggleMenu={toggleMenu} 
        setToggleMenu={setToggleMenu}
      />
      {toggleMenu && <MenuTab toggleMenu={toggleMenu} 
        setToggleMenu={setToggleMenu}
      />}
      <div className="image">
        <div>
          <p>Our Board of Directors</p>
        </div>
      </div>
      <div className="board">
        <div className="persons">
          <Person name = "Godfrey Mwaura Kigochi" photo = {Godfrey} designation = "Chairman" academics={["Masters of Science in Project Management", "Bachelors of Arts in Public Administration"]}/>
        </div>
        <div className="persons">
          <Person name = "Vacant" photo = {personicon} designation = "Director" academics={["."]} />
          <Person name = "Grace Nduta Gitau" photo = {Grace} designation = "Director" academics={["Diploma in IATA/FIATA", "Security Management Administration Police Training"]} />
          <Person name = "Fr. Silas Ngaruiya" photo = {Silas} designation = "Director" academics={["."]} />
          {/* <Person name = "Vacant" photo = {personicon} designation = "Director" academics={["."]} /> */}
          <Person name = "Rev. Peter Wangaruro" photo = {Peter} designation = "Director" academics={["."]} />
          <Person name = "Henry Waweru" photo = {personicon} designation = "Chief Officer – Finance & Economic Planning Kiambu County" academics={["PhD in Business Administration", "Masters of Business Administration (Finance)", "Bachelor of Business Administration"]} />
          <Person name = "Kang'ara GN" photo = {GNKangara} designation = "Director" academics={[".", "Master of Laws", "Bachelor of Law", "_"]} />
          {/* <Person name = "Vacant" photo = {personicon} designation = "Director" academics={["."]} /> */}
          {/* <Person name = "Edmund Njihia" photo = {Edmund} designation = "Chief Officer – WEENR Kiambu County" academics={["."]} /> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

const Person = (props) => {
  return (
    <div className="person">
      <div className="photo">
        <img src={props.photo} alt="" />
      </div>
      <div className="details">
        <h3>{props.name}</h3>
        <p className="designation">{props.designation}</p>
        {props.academics?.map((item, index) => <p className="academics" id={index}>{item}</p>)}
      </div>
    </div>
  )
} 